import { useState } from "react";
import { KeyRound, MailCheck, MailWarning } from "lucide-react";
import { api, errMsg } from "../lib/api";

export const ResendVerification = ({ testId = "resend-verification-button" }) => {
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      setMsg((await api.post("/auth/resend-verification")).data.message);
    } catch (err) {
      setMsg(errMsg(err, "Gagal mengirim ulang"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <span className="row-end">
      <button className="outline sm" disabled={busy} onClick={resend} data-testid={testId}>{busy ? "Mengirim…" : "Kirim ulang link"}</button>
      {msg && <small data-testid={`${testId}-result`}>{msg}</small>}
    </span>
  );
};

export const VerifyBanner = ({ user }) => (user.email_verified === false ? (
  <div className="verify-banner" data-testid="verify-email-banner">
    <MailWarning size={17} />
    <span>Email <b>{user.email}</b> belum diverifikasi. Cek kotak masuk Anda — transaksi (sewa EA, bayar sharing, tarik komisi) aktif setelah verifikasi.</span>
    <ResendVerification />
  </div>
) : null);

export default function Security({ user, onTokenRotated }) {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");
    if (form.new_password !== form.confirm) return setError("Konfirmasi password baru tidak sama.");
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      localStorage.setItem("tp_token", r.data.token);
      onTokenRotated?.();
      setMsg(r.data.message);
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      setError(errMsg(err, "Gagal mengubah password"));
    } finally {
      setBusy(false);
    }
  };
  const verified = user.email_verified !== false;
  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">AKUN</p><h2>Keamanan akun</h2><p className="muted">Kelola password dan status verifikasi email Anda.</p></div>
      </div>
      <div className="integration-grid">
        <form className="panel integration-card" onSubmit={submit} data-testid="change-password-form">
          <div className="panel-head"><div><p className="eyebrow">PASSWORD</p><h3>Ganti password</h3></div><KeyRound size={18} /></div>
          <label>Password saat ini<input type="password" required value={form.current_password} onChange={set("current_password")} data-testid="current-password-input" /></label>
          <label>Password baru<input type="password" required minLength={6} value={form.new_password} onChange={set("new_password")} data-testid="new-password-input" /></label>
          <label>Ulangi password baru<input type="password" required minLength={6} value={form.confirm} onChange={set("confirm")} data-testid="confirm-new-password-input" /></label>
          {msg && <div className="notice" data-testid="change-password-success">{msg}</div>}
          {error && <div className="error" data-testid="change-password-error">{error}</div>}
          <button className="primary" disabled={busy} data-testid="change-password-submit">{busy ? "Menyimpan…" : "Simpan password baru"}</button>
        </form>
        <div className="panel integration-card">
          <div className="panel-head"><div><p className="eyebrow">EMAIL</p><h3>Verifikasi email</h3></div>
            <span className={verified ? "pill ok" : "pill warn"} data-testid="email-verified-status">{verified ? "Terverifikasi" : "Belum diverifikasi"}</span></div>
          <p className="muted inline-icon"><MailCheck size={14} /> {user.email}</p>
          <p className="muted">{verified ? "Email Anda sudah terverifikasi. Notifikasi dan link reset password dikirim ke alamat ini." : "Klik link di email verifikasi. Belum menerima? Kirim ulang di bawah (maks. 3 kali per jam)."}</p>
          {!verified && <div className="mt"><ResendVerification testId="security-resend-button" /></div>}
        </div>
      </div>
    </>
  );
}
